import ChartAnswer from './ChartAnswer';
import './ChartPanel.css';

interface ChartPanelProps {
  questionNumber: number;
  questionText: string;
  answers: string[];
  count: Record<string, number>;
  totalRespondents: number;
  showCount?: boolean;
}

function ChartPanel({
  questionNumber,
  questionText,
  answers,
  count,
  totalRespondents,
  showCount = true,
}: ChartPanelProps) {
  const calculatePercentage = (answerCount: number): string => {
    if (!answerCount || !totalRespondents) return '0%';
    return Math.round((answerCount * 100) / totalRespondents) + '%';
  };

  return (
    <div className="chart__panel">
      <h3 className="chart__question">
        {questionNumber + 1}. {questionText}
      </h3>
      <div className="chart__answers">
        {answers.map((answer, index) => {
          const answerCount = count[index] || 0;
          const percentage = calculatePercentage(answerCount);

          return (
            <ChartAnswer
              key={`${answer}-${Date.now()}`}
              answer={answer}
              percentage={percentage}
              count={showCount ? answerCount : undefined}
            />
          );
        })}
      </div>
    </div>
  );
}

export default ChartPanel;
